<template>
    <ToggleSimple>
        <template #toggle>
            <div class="left">
                <div v-if="$te(`fields.${name}.label`)" class="toggle-text">
                    {{ $t(`fields.${name}.label`) }}

                    <span v-if="isActive">
                        <div class="icon-check-dark"></div>
                    </span>
                </div>
            </div>
            <div class="right">
                <div v-if="isActive" class="reset" @click="resetSection">
                    <div class="icon-reset-pos"></div>
                </div>
                <div class="toggle-icon"></div>
            </div>
        </template>

        <template #content>
            <CustomRange
                inputKey="reviews"
                :modelValue="reviews"
                :min="min"
                :max="max"
                :showLabel="false"
                :showLabelMinMax="true"
                @update:modelValue="onRangeChanged"
            />
        </template>
    </ToggleSimple>
</template>

<script>
    import ToggleSimple from '@/components/elements/misc/ToggleSimple';
    import CustomRange from '@/components/elements/inputs/CustomRange';

    export default {
        name: "OptionsReviews",
        components: {
            ToggleSimple,
            CustomRange
        },
        props: {
            modelValue: {
                type: String,
                default: ''
            },
            cssClass: {
                type: String,
                required: false
            }
        },
        data() {
            return {
                name: 'reviews',
                min: 0,
                max: 1000,
                reviews: {
                    min: this.modelValue.includes(':') ? parseInt(this.modelValue.split(':')[0])  : this.min,
                    max: this.modelValue.includes(':') ? parseInt(this.modelValue.split(':')[1]) : this.max
                }
            };
        },
        computed: {
            isActive() {
                return this.modelValue !== '';
            }
        },
        methods: {
            resetSection(event = null) {
                if (event) {
                    event.stopPropagation()
                }
                this.reviews = { min: '', max: '' };
                this.$emit('update:modelValue', '');
            },
            onRangeChanged(value) {
                var { min, max } = value;
                let reviews = '';

                if(min !== undefined && min === this.min && max && max === this.max) {
                    reviews = '';
                } else if(min && min !== '' && max && max !== '') {
                    reviews = `${min}:${max === this.max ? this.max * 100000 : max}`;
                } else if(min && min !== '') {
                    reviews = `${min}:${this.max * 100000}`;
                } else if(max && max !== '') {
                    reviews = `0:${max === this.max ? this.max * 100000 : max}`;
                }
                this.$emit('update:modelValue', reviews);
            }
        },
        watch: {
            modelValue(newVal) {
                if(newVal === '') {
                    this.reviews = { min: '', max: '' };
                } else {
                    const [min, max] = newVal.split(':').map(Number);
                    this.reviews = { min, max };
                }
            }
        },
    }
</script>
